import React from "react";
import Intro from "./Intro/Intro";
import Welcome from "./Welcome/Welcome";
import Feature from "./Feature/Feature";
import { useQuery } from "@tanstack/react-query";
import Blog from "./Blog/Blog";
import Quote from "./Quote/Quote";
import Promotion from "./Feature/Promotion";
import { useSelector } from "react-redux";
import { getSingleWebsite } from "../../lib/Services_with_Query";
import Loader from "../../Component/Loader/Loader";

const Home = (sectionId) => {
  const section = document.getElementById(sectionId);
  if (section) {
    const yOffset = -50;
    const y =
      section.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }
  const { website } = useSelector((state) => state?.website || {});
  const website_id = website?.website_id && website?.website_id;
  const agent_id = website?.agent_id && website?.agent_id;
  const shouldFetch = website_id && agent_id ? true : false;

  const { isLoading: isWebsiteLoading } = useQuery({
    queryKey: ["website"],
    queryFn: () => getSingleWebsite(website_id),
    enabled: shouldFetch,
  });

  if (isWebsiteLoading) return <Loader />;

  return (
    <>
      <Intro id={"Intro"} />

      <Welcome />
      <Feature id={"Feature"} website_id={website_id} agent_id={agent_id} />
      {/* <FeatureServices/> */}
      {/* <Teams /> */}
      {/* <Project /> */}
      {/* <Counter /> */}
      <Promotion id={"Feature"} />
      <Blog website_id={website_id} agent_id={agent_id} />
      <Quote website_id={website_id} agent_id={agent_id} />
    </>
  );
};

export default Home;
